import { styled, theme, Currency } from '@teko/ui';
import React from 'react';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const Wrapper = styled.div(({ isSelected, isPackage }) => `
  display: flex;
  cursor: pointer;
  margin: 0.25rem 0.5rem 0.25rem 0;
  flex-direction: column;
  position: relative;
  ${isSelected ? `border: 1px solid ${theme.brand.primary};` : ""}
  ${isPackage ? `
  min-width: 30%;
  border: 1px solid #e4e5f0;
  height: 76px;
  background: #fbfbfd;
  box-sizing: border-box;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 0.5rem;
  ` : ""} 
  `);
const PriceTag = styled.span(({ isSelected }) => `
position: absolute;
top: 0;
width: fit-content;
background: #bcbfd6;
border-radius: 0px 0px 4px 4px;
color: #fff;
font-weight: 500;
font-size: 12px;
line-height: 16px;
padding: 2px 8px;
${isSelected && `background: ${theme.brand.primary};`}
`);
const PriceWrapper = styled.div(({ hasTag }) => `
    ${hasTag && `margin-top: 18px;`}
`);
const Price = styled.div(({ isSelected, isPackage }) => `
    color: ${isSelected ? `${theme.colors.blue600};` : " #82869E;"}
    font-weight: bold;
    font-size: ${isPackage ? "20px" : "24px"};
    line-height: 28px;
`);
const ListedPrice = styled.div`
  font-size: 13px;
  line-height: 18px;
`;
const SupplierSalePrice = styled(Currency)`
  color: #82869e;
  text-decoration: line-through;
`;
const PricePackage = ({
  prices,
  selectedPrice,
  setSelectedPrice,
  selectionPromotions
}) => {
  return /* @__PURE__ */ React.createElement(Container, null, prices.map((price, index) => /* @__PURE__ */ React.createElement(Wrapper, {
    isPackage: prices.length > 1 || ((selectionPromotions == null ? void 0 : selectionPromotions.length) || 0) > 1,
    isSelected: prices.length > 1 && selectedPrice === price.sellPrice,
    key: index,
    onClick: () => setSelectedPrice == null ? void 0 : setSelectedPrice(price.sellPrice === null ? null : Number(price.sellPrice))
  }, price.tag && /* @__PURE__ */ React.createElement(PriceTag, {
    isSelected: selectedPrice === price.sellPrice
  }, price.tag), /* @__PURE__ */ React.createElement(PriceWrapper, {
    hasTag: !!price.tag
  }, /* @__PURE__ */ React.createElement(Price, {
    isSelected: selectedPrice === price.sellPrice,
    isPackage: prices.length > 1 || ((selectionPromotions == null ? void 0 : selectionPromotions.length) || 0) > 1
  }, /* @__PURE__ */ React.createElement(Currency, {
    value: price.sellPrice || 0
  })), price.supplierSalePrice && price.supplierSalePrice !== price.sellPrice && /* @__PURE__ */ React.createElement(ListedPrice, null, /* @__PURE__ */ React.createElement(SupplierSalePrice, {
    value: price.supplierSalePrice
  }))))));
};

export { PricePackage };
